import googleAnalytics from '@analytics/google-analytics';
import Analytics, {AnalyticsInstance} from 'analytics';
import {UISettingsRecord} from '../../records/ui-settings.record';

type TEventCategory = 'support' | 'sales' | 'action' | 'screen';
type TEventAction = 'open' | 'create' | 'edit' | 'start' | 'send' | 'remove';
let analyticsResolve;
export const analyticsReady = new Promise<AnalyticsInstance>((resolve) => (analyticsResolve = resolve));

export function analyticsInit(settings: UISettingsRecord) {
    const plugins = [];
    if (settings.gaTrackingId) {
        plugins.push(
            googleAnalytics({
                measurementIds: [settings.gaTrackingId],
                autoTrack: true
            })
        );
    }
    analyticsResolve(
        Analytics({
            app: 'vue-ui',
            debug: IS_DEBUG,
            plugins
        })
    );
}

export async function trackEvent(category: TEventCategory, event: string, action?: TEventAction, label?: any) {
    const analytics = await analyticsReady;
    analytics.track(event, {
        category,
        action,
        label
    });
}
